import { useQuery } from "@tanstack/react-query";
import tourPackagesService from "services/admin/tour-packages.service";

export const useGetTourPackageDetails = (id) => {
    return useQuery({
        queryKey: ['tourPackageDetails', id],
        queryFn: async () => {
            const { data } = await tourPackagesService.get(id)
            return data
        }
    })
}